import {ApiResponseDto, BasePopupProps, NameWithId} from "@utils/Models";
import React, {useEffect, useState} from "react";
import {
    useFlintNotificationContext
} from "@components/page_components/common/notifications/FlintNotificationContext";
import axios from "axios";
import {
    ApiUrl_Orders_AssignCoordinator,
    ApiUrl_Orders_GetCoordinatorList
} from "@utils/Endpoints";
import FlintLoadingWrapper from "@components/page_components/common/loading/FlintLoadingWrapper";
import FlintDropDownList from "@components/controls/FlintDropDownList";
import {WindowActionsBar} from "@progress/kendo-react-dialogs";
import FlintButton from "@components/controls/FlintButton";
import {
    AssignCoordinatorRequest,
    OrderPreviewModel, OrderPreviewModelStateType
} from "../../order.models";
import {Trans, useTranslation} from "react-i18next";
import {useFlintDialogContext} from "@components/page_components/common/dialogs/FlintDialogContextProvider";

export default function AssignCoordinatorComponent(props: AssignCoordinatorComponentProps) {
    const {state, handlers} = useAssignCoordinatorComponent(props);
    const {t} = useTranslation();
    return (
        <FlintLoadingWrapper showLoading={state.isLoadingState.get}>
            <div className="p-2">
                <div>
                    <div className={"form-group"}>
                        <FlintDropDownList<NameWithId> label={t("COMMON_Coordinator")}
                                                       dataSource={state.userListState.get}
                                                       selectedValue={state.selectedLabState.get}
                                                       onItemSelected={handlers.handleUserSelected}/>
                    </div>
                </div>
                <WindowActionsBar layout={"center"}>
                    <FlintButton disabled={state.isLoadingState.get} themeColor={"secondary"}
                                 onClick={handlers.handleCancelled}>{t("Cancel")}</FlintButton>
                    <FlintButton disabled={state.isLoadingState.get || !state.selectedLabState.get}
                                 themeColor={"primary"}
                                 onClick={handlers.handleConfirmed}>{t("Confirm")}</FlintButton>
                </WindowActionsBar>
            </div>
        </FlintLoadingWrapper>)
}

export interface AssignCoordinatorComponentProps extends BasePopupProps {
    orderPreviewModelState: OrderPreviewModelStateType
}

function useAssignCoordinatorComponent(props: AssignCoordinatorComponentProps) {
    const [isLoading, setIsLoading] = useState(false);
    const [userList, setUserList] = useState<NameWithId[]>([]);
    const [selectedUser, setSelectedUser] = useState<NameWithId>();
    const {showNotification} = useFlintNotificationContext();
    const {showConfirmDialog} = useFlintDialogContext();
    const {t} = useTranslation();
    const visibilityState = props.orderPreviewModelState.get.ElementVisibility;
    const basicDataState = props.orderPreviewModelState.get.OrderBasicData;
    useEffect(() => {
        if (!visibilityState.ProjectAssignAnotherUserAsCoordinatorVisible) {
            props.OnCancelled();
            showNotification("You are not allowed to perform this action", {style: "error"})
            return;
        }
        loadUserList().catch();
    }, [])

    function loadUserList() {
        setIsLoading(true);
        const params = {orderGuid: basicDataState.Guid}
        return axios.get<ApiResponseDto<NameWithId[]>>(ApiUrl_Orders_GetCoordinatorList, {params: params})
            .then(res => {
                let userList = res.data.Result;
                setUserList(userList);
            })
            .catch(err => showNotification(err))
            .finally(() => setIsLoading(false))
    }

    function handleUserSelected(user: NameWithId) {
        setSelectedUser(user);
    }

    function handleCancelled() {
        props.OnCancelled();
    }

    function handleConfirmed() {
        // const confirmation = <>Are you sure, you want to assign<br/><b>{selectedUser?.Name}</b><br/>to this project as a
        //     coordinator?</>;
        //const confirmation = <>{t("ORDER_PREVIEW_PROJECT_LabelAssignCoordinatorConfirmation",  { name: selectedUser!.Name })}</>;
        const confirmation = (
            <Trans
                i18nKey="ORDER_PREVIEW_PROJECT_LabelAssignCoordinatorConfirmation"
                values={{ name: selectedUser?.Name }}
                components={{ br: <br />, b: <b /> }}
            />
        );
        showConfirmDialog({
            title: t("COMMON_PleaseConfirm"),
            content: confirmation,
            acceptButtonText: t("COMMON_IAmSure"),
            cancelButtonText: t("Cancel"),
            onAccept: () => {
                const post: AssignCoordinatorRequest = {
                    OrderGuid: basicDataState.Guid,
                    CoordinatorId: selectedUser!.Id
                }
                setIsLoading(true);
                axios.post<ApiResponseDto<OrderPreviewModel>>(ApiUrl_Orders_AssignCoordinator, post)
                    .then(response => {
                        props.orderPreviewModelState.setModel(response.data.Result);
                        showNotification(t("ORDER_PREVIEW_PROJECT_LabelAssignCoordinatorCompleted"), {style: "success"});
                        props.OnConfirmedAndSaved();
                    })
                    .catch(error => showNotification(error))
                    .finally(() => setIsLoading(false));
            }
        })
    }

    return {
        state: {
            isLoadingState: {get: isLoading},
            userListState: {get: userList},
            selectedLabState: {get: selectedUser},
        },
        handlers: {handleConfirmed, handleCancelled, handleUserSelected}
    }
}